export enum StepKey {
    Welcome = 'welcome',
    PersonalInfo = 'personalInformation',
    AcademicBackground = 'academicBackground',
    ContactInfo = 'contactInformation',
    StudyPreferences = 'studyPreferences',
    AbroadLocation = 'abroadLocation',
    ColombiaLocation = 'colombiaLocation',
    FuturePlans = 'futurePlans',
    UniversityPref = 'universityPreference',
    CareerPref = 'careerPreferences',
    AcademicPerf = 'academicPerformance',
    Language = 'languageProficiency',
    CareerMotivations = 'careerMotivations',
    StandardizedTests = 'standardizedTests',
    Skills = 'skills',
    Financial = 'financialInformation',
    Icfes = 'icfesReadiness',
    Guardian = 'guardianInformation'
  }
  